import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            编辑团队为你精心挑选的必读佳作
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cardsData.slice(0, 3).map((card) => (
              <a
                key={card.id}
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{card.subtitle}</span>
                  <h3 className="mt-1 text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {cardsData.slice(3, 5).map((card) => (
              <a
                key={card.id}
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex flex-col sm:flex-row bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative sm:w-48 aspect-[4/3] sm:aspect-auto overflow-hidden shrink-0">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{card.subtitle}</span>
                  <h3 className="mt-1 text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}